// =============================================================================
// App-wide configuration constants.
// Update these values each semester when refreshing the data.
// =============================================================================

// The current academic year (used to determine the year range shown in views).
export const CURRENT_YEAR = 2026;

// The current broad semester (e.g., "Spring", "Fall", "Summer").
export const CURRENT_SEMESTER = "Fall";

// The date the data was last scraped / updated, shown in the header.
export const LAST_UPDATED_DATE = "8/19/2026";

// A human-readable label for the semester the data covers.
export const LAST_UPDATED_SEMESTER = "Fall 2026";
